import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Unsubscribe() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [state, setState] = useState("loading");
  useEffect(() => {
    api.get(`/comms/unsubscribe/${token}`).then((r) => { setInfo(r.data); setState(r.data.status === "unsubscribed" ? "done" : "ready"); }).catch(() => setState("invalid"));
  }, [token]);
  const go = async () => { try { await api.post(`/comms/unsubscribe/${token}`); setState("done"); } catch { setState("invalid"); } };
  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center" data-testid="unsubscribe-page">
      <div className="eyebrow mb-2">Temple of the Human Heart</div>
      {state === "invalid" && <p className="font-serif text-2xl" style={{ color: "var(--burgundy)" }}>This link is not valid.</p>}
      {state === "ready" && (
        <>
          <h1 className="font-serif text-3xl mb-3" style={{ color: "var(--burgundy)" }}>Unsubscribe from Temple email?</h1>
          <p className="text-sm mb-6" style={{ color: "var(--text-muted)" }}>{info?.email_hint} will no longer receive teachings, gatherings, or updates by email.</p>
          <button data-testid="unsubscribe-confirm-btn" onClick={go} className="rounded-full px-5 py-2.5 text-sm font-medium" style={{ background: "var(--burgundy)", color: "var(--bg-cream)" }}>Unsubscribe</button>
        </>
      )}
      {state === "done" && (
        <>
          <h1 className="font-serif text-3xl mb-3" style={{ color: "var(--burgundy)" }} data-testid="unsubscribe-done">You have been unsubscribed.</h1>
          <p className="text-sm" style={{ color: "var(--text-muted)" }}>You are always welcome here. <Link to="/" className="ink-link" style={{ color: "var(--burgundy)" }}>Return to the Temple →</Link></p>
        </>
      )}
    </div>
  );
}
